import { Component } from '@angular/core';

@Component({
  selector: 'app-header-top',
  templateUrl: './header-top.component.html',
  styleUrl: './header-top.component.css'
})
export class HeaderTopComponent {

}
